export default {
  strict: true,
  namespaced: true,
  state: {
    visualizationGroupType: 'Group1',
  },
  mutations: {
    setVisualizationGroupType(state, visualizationGroupType){
      state.visualizationGroupType = visualizationGroupType;
    }
  },
};



// WEBPACK FOOTER //
// ./src/stores/map/data/map_group.js